import React from "react";
import {Checkbox as MuiCheckbox, FormControlLabel} from "@mui/material";
import { ValidatedValue } from "../../../../helpers/validatedValue";
import {observer} from "mobx-react";

interface CheckboxProps {
    label?: string;
    disabled?: boolean;
    required?: boolean;
    size?: "small" | "medium" | undefined;
    validatedValue: ValidatedValue<boolean>;
    testId: string;
    onChange?: (value: boolean) => void;
}

function Checkbox(props: CheckboxProps) {
    return (
        <div className="checkbox">
            <FormControlLabel
                control={
                    <MuiCheckbox
                        onChange={onChange}
                        checked={getValue()}
                        size={props.size}
                        required={props.required}
                        disabled={props.disabled}
                        data-testid={props.testId}
                    />
                }
                label={props.label}
            />
        </div>
    );

    function onChange(event: React.ChangeEvent<HTMLInputElement>) {
        const value = event.target.checked;

        if(props.onChange) {
            props.onChange(value);
        }
        props.validatedValue.clearValidation();
        props.validatedValue.setValue(value);
    }

    function getValue() {
        return props.validatedValue.value;
    }
}

export default observer(Checkbox);
